module.exports = __webpack_public_path__ + "static/media/xchange.e39b9360.png";